import { useMemo, useRef } from "react";
function useConstant(fn) {
  if (typeof document === "undefined") {
    return useMemo(() => fn(), []);
  }
  const ref = useRef();
  if (!ref.current) {
    ref.current = { v: fn() };
  }
  return ref.current.v;
}
export {
  useConstant
};
//# sourceMappingURL=index.js.map
